import { render, staticRenderFns } from "./UserCollect.vue?vue&type=template&id=da62d512&scoped=true&"
import script from "./UserCollect.vue?vue&type=script&lang=js&"
export * from "./UserCollect.vue?vue&type=script&lang=js&"
import style0 from "./UserCollect.vue?vue&type=style&index=0&id=da62d512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da62d512",
  null
  
)

export default component.exports